import React from "react"
import styled from 'styled-components'
import { Link } from 'gatsby'

import HeroLayout from "../components/hero"
import SEO from "../components/seo"

const HeroButton = styled.button`
  color: white;
  font-size: 1.5em;
  padding: 0.5rem 2rem;
  border: white 3px solid;
  border-radius: 0.4rem;
  background: transparent;
  width: 100%;
  outline: none;
  font-weight: bold;
  transition: background-color ease-out 0.3s;

  &:hover {
    background-color: white;
    color: #201010;
    cursor: pointer;
  }
`

const HeroText = styled.h1`
  font-size: 3em;
`

const IndexPage = () => (
  <HeroLayout>
    <SEO title="Strona Główna" keywords={[`gatsby`, `portfolio`, `react`, `javascript`]} />
    <HeroText>Zawistowski</HeroText>
    <Link to="/projects">
      <HeroButton>PORTFOLIO</HeroButton>
    </Link>
  </HeroLayout>
)

export default IndexPage
